import Vue from "vue"
import swal from "sweetalert2";

Vue.filter('price', function (value, options = {}) {
    return new Intl.NumberFormat('ro-RO', Object.assign({ style: 'currency', currency: 'RON', minimumFractionDigits: 2}, options)).format(Number(value));
})
Vue.filter('number', function (value, options = { maximumFractionDigits: 2}) {
    return new Intl.NumberFormat('ro-RO', options).format(Number(value));
})
Vue.filter('date', function (value) {
    return new Intl.DateTimeFormat('ro-RO', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    }).format(value);
})
Vue.filter('dateWithDay', function (value) {
    return new Intl.DateTimeFormat('ro-RO', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long'
    }).format(value);
})
Vue.filter('percent', function (value, options = {minimumFractionDigits: 2}) {
    if (value === undefined) value = '0'
    return parseFloat(value).toFixed(options.minimumFractionDigits) + '%'
})

Vue.filter('datetime', function (value) {
    try {
        return new Intl.DateTimeFormat('ro-RO', {
            timeStyle: 'short',
            dateStyle: 'full'
        }).format(value);
    } catch (e) {
        console.error(e)
        return value
    }
})
Vue.filter('shortdatetime', function (value) {
    try {
        return window.moment(value).format('DD.MM, HH:mm');
    } catch (e) {
        console.error(e)
        return value
    }
})
Vue.filter('shorttime', function (value) {
    try {
        return new Intl.DateTimeFormat('ro-RO', {
            timeStyle: 'short',
            dateStyle: undefined
        }).format(value);
    } catch (e) {
        console.error(e)
        return value
    }
})
Vue.filter('shortdate', function (value) {
    try {
        return new Intl.DateTimeFormat('ro-RO', {
            timeStyle: undefined,
            dateStyle: 'short'
        }).format(value);
    } catch (e) {
        console.error(e)
        return value
    }
})

Vue.mixin({
    computed: {
        colorScheme() {
            return [
                "#25CCF7","#FD7272","#54a0ff","#00d2d3",
                "#1abc9c","#2ecc71","#3498db","#9b59b6","#34495e",
                "#16a085","#27ae60","#2980b9","#8e44ad","#2c3e50",
                "#f1c40f","#e67e22","#e74c3c","#ecf0f1","#95a5a6",
                "#f39c12","#d35400","#c0392b","#bdc3c7","#7f8c8d",
                "#55efc4","#81ecec","#74b9ff","#a29bfe","#dfe6e9",
                "#00b894","#00cec9","#0984e3","#6c5ce7","#ffeaa7",
                "#fab1a0","#ff7675","#fd79a8","#fdcb6e","#e17055",
                "#d63031","#feca57","#5f27cd","#54a0ff","#01a3a4"
            ]
        },
        generalPaymentTypes() {
            return {
                'TICKET': 'Tichet',
                'CASH': 'Numerar',
                'BANK_TRANSFER': 'Transfer bancar',
            }
        }
    },
    methods: {
        showError(title = 'Va rugam sa verificati datele introduse.') {
            const validationModal = swal.mixin({
                confirmButtonClass: "v-btn blue-grey  subheading white--text",
                buttonsStyling: false,
                target: '.v-application'
            });
            validationModal.fire({
                title: `Eroare`,
                html: `<p class="title">${title}</p>`,
                type: "warning",
                confirmButtonText: "Inapoi"
            });
        },
        showSuccess(text = 'Datele au fost salvate cu success!') {
            const successModal = swal.mixin({
                confirmButtonClass: "ml-2 v-btn v-btn--contained theme--dark v-size--default primary",
                buttonsStyling: false,
                target: '.v-application'
            });
            successModal.fire({
                title: "Success!",
                html: `<p class="title">${text}</p>`,
                type: "success",
                confirmButtonText: "Inapoi"
            });
        },
        async asyncForEach(array, callback) {
            for (let index = 0; index < array.length; index++) {
                await callback(array[index], index, array);
            }
        },
        async uploadFile(path, files) {
            var formData = new FormData();
            files.forEach((item) => {
                formData.append(item.name, item.file);
            })
            return window.axios.post(path, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
        },
        async downloadFile(path, params = {}) {
            return new Promise((resolve, reject) => {
                return window.axios.get(path, {
                    responseType: 'blob',
                    params: params
                }).then((response) => {
                    const contentDisposition = this._.get(response, 'headers.content-disposition')
                    const filename = contentDisposition.split("filename=")[1].replaceAll('"', "");
                    const downloadUrl = window.URL.createObjectURL(new Blob([response?.data]));
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.setAttribute('download', filename); //any other extension
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    resolve(true)
                }).catch((e) => {
                    try {
                        let reader = new FileReader()
                        reader.addEventListener('loadend', () => {
                            var jsonResponse = JSON.parse(reader.result)
                            reject(jsonResponse.message)
                        })
                        reader.readAsText(e.response.data)
                    } catch (e) {
                        reject("Eroare necunoscuta.")
                    }
                })
            })
        },
        async streamFile(path) {
            return new Promise((resolve, reject) => {
                return window.axios.get(path, {
                    responseType: 'blob'
                }).then((response) => {
                    resolve(
                        window.URL.createObjectURL(new Blob([response?.data]))
                    )
                }).catch((e) => {
                    try {
                        let reader = new FileReader()
                        reader.addEventListener('loadend', () => {
                            var jsonResponse = JSON.parse(reader.result)
                            reject(jsonResponse.message)
                        })
                        reader.readAsText(e.response.data)
                    } catch (e) {
                        reject("Eroare necunoscuta.")
                    }
                })
            })
        },
        getConfig(key, fallback) {
            return this.$store.getters['workstation/getConfig'](key, fallback)
        },
        strRandom(len) {
            let text = " "
            let chars = "abcdefghijklmnopqrstuvwxyz"

            for( let i=0; i < len; i++ ) {
                text += chars.charAt(Math.floor(Math.random() * chars.length))
            }

            return text
        }
    }
})
